import { Button, Dropdown, Space } from "antd"
import React, { Key, useState } from "react"
import { setStateType } from "../../../types/setStateType"
import { ICampaignDataColumns } from "../types/table"
import { MENU_PROPS_ITEMS } from "../constants/campaignActions.constants"
import { options } from "../types/campaignActions"
import { applyOnAmazon, handleMenuClick } from "../services/campaignActions"
import AddCampaignToProject from "../../../components/AddCampaignToProject"

interface ICampaignActions {
  selectedRowCampaignIds: Key[]
  setSelectedRowCampaignIds: setStateType<Key[]>
  selectedTargetRowCampaignIds: Key[]
  setCampaigns: setStateType<any>
  campaigns: ICampaignDataColumns[]
}

const CampaignActions: React.FC<ICampaignActions> = ({
  selectedRowCampaignIds,
  setSelectedRowCampaignIds,
  selectedTargetRowCampaignIds,
  setCampaigns,
  campaigns,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const menuProps = {
    items: MENU_PROPS_ITEMS,
    onClick: (event) =>
      handleMenuClick({
        event,
        setCampaigns,
        selectedRowCampaignIds,
        setSelectedRowCampaignIds,
        selectedTargetRowCampaignIds,
        campaigns,
        setIsOpen,
      }),
  }

  return (
    <Space>
      <AddCampaignToProject
        campaignIds={selectedRowCampaignIds.map((id) => Number(id))}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
      />

      <Button onClick={() => applyOnAmazon(campaigns, selectedTargetRowCampaignIds)}>
        {options.APPLY_ON_AMAZON}
      </Button>
      <Dropdown.Button menu={menuProps}>Actions</Dropdown.Button>
    </Space>
  )
}

export default CampaignActions
